import styled from 'styled-components';

const ICON_GUTTER = '3.2rem';

export const IconSlot = styled.span`
    position: absolute;
    left: 1.1rem;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    display: inline-flex;
`;

export const Positioned = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 0;

    & .ant-select-selector {
        padding-left: ${ICON_GUTTER} !important;
    }

    /* antd insets the search input with a hardcoded 11px, so it has to be moved separately. */
    & .ant-select-selection-search {
        left: ${ICON_GUTTER} !important;
    }

    & .ant-picker-input > input {
        padding-left: 2.1rem;
    }
`;

export const IconWrapper = styled.span<{ $color: string; $backgroundColor: string; $borderColor: string }>`
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${({ $color }) => $color};
    background-color: ${({ $backgroundColor }) => $backgroundColor};
    border: ${({ $borderColor }) => `1px solid ${$borderColor}`};
    border-radius: 2px;
    font-size: 10px;
    width: 16px;
    height: 16px;
`;
